import useTranslation from 'hooks/useTranslation/useTranslation';
import * as React from 'react';
import useModalContext from 'v2/components/Modal/useModalContext';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import WizardModalTemplate, { WizardStep } from 'v2/components/WizardModal/WizardModalTemplate';
import SetupStep from './SetupStep';
import VerifyStep from './VerifyStep';

interface Props {
  onComplete: () => void;
}

const TwoFactorSetupModal: React.FC<Props> = ({ onComplete }) => {
  const { translation } = useTranslation();
  const { closeModal } = useModalContext();
  const { showSnackbar } = useSnackbarContext();

  const steps: WizardStep[] = [{ label: translation.setup }, { label: translation.verification }];

  const handleComplete = () => {
    onComplete();
    showSnackbar(translation.two_factor_authentication_enabled_successfully, { severity: 'success' });
    closeModal();
  };

  return (
    <WizardModalTemplate title={translation.two_factor_authentication} steps={steps}>
      <SetupStep />
      <VerifyStep onComplete={handleComplete} />
    </WizardModalTemplate>
  );
};

export default TwoFactorSetupModal;
